import {NodeType} from "prosemirror-model";
import {EditorState, NodeSelection} from "prosemirror-state";

export const isAttributeValueActive = (
    nodeType: NodeType,
    attributeName: string,
    attributeValue: any
) => (
    state: EditorState
): boolean => {
    const { selection } = state;
    const { node } = selection as NodeSelection;

    // Check if there's a node selection and if it's of the specified type
    if (node && node.type === nodeType) {
        // Check if the node's specified attribute has the expected value
        return node.attrs[attributeName] === attributeValue;
    }

    return false;
}
